
/*@@
@Name: es-ES.jsx
@Description: Localization file including date formatting
@Note: Convention. UPPER_CASE means it is also an endpoint. But this will go away
       For copy paste:  á é í ó ú ñ
@Usage
   Implicitly used by AppLoader
*/



export default {

    digital_risk_and_compliance: "Digital Risk & Compliance",

    //error messages
    error_message_generic: 'Cannot load data. Please refresh or try again later.',
    error_message_timeout: 'Request took too long. Please refresh or try again later.',

    NUMBER_FORMAT: "{n, number}",
    id: 'ID',
    property: 'Tipo de cuenta',
    logo: "Logo",
    enter_keywords: 'Enter a keyword',
    //catalog
    catalog: 'Catálogo',
    //pods
    window: 'Rango',
    pod_summary: 'Summary',
    pod_alerts: 'Alerts',
    pod_roi: 'ROI',
    pod_lockbox: 'Password Lockbox',
    pod_tasks: 'User Tasks',
    settings_pod: 'Pod Settings',
    pod_risk_scores_bundle: 'Risk Scores Bundle',
    pod_risk_event_summary: 'Risk Event Summary',
    top_seeds_by_detections: 'Top Seeds by Detection Count',
    top_classifications_by_detections: 'Top Domain Classifications',
    recent_changes_to_suspicious_domains: 'Recent Changes to Suspicious Domains',
    recent_tap_detections: 'Domains with Recent TAP Detections',
    //I18n
    DATE_M_Y_time : "{value, date, short}",
    DATE_short: "{value, date, short}",
    DATE_medium: "{value, date, medium}",
    DATE_long: "{value, date, long}",
    DATE_full: "{value, date, full}",
    TIME_short: "{value, time, short}",
    TIME_medium: "{value, time, medium}",
    TIME_long: "{value, time, long}",
    es: 'Español',
    'es-ES': 'Español (Castellano)',
    en: 'Inglés',
    'en-US': 'Inglés (U.S.A.)',
    cn: 'Chino',
    'zh-CN': 'Chino (Simplificado)',
    hello: 'Hola',
    HELLO: "Hola, {name}. Bienvenido a {where}!",
    //nav
    total: 'Total',
    page: 'Página',
    //nav
    //forms
    submit: 'Enviar',
    reset:   'Reiniciar',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    add: 'Add',
    remove: 'Remove',
    close: 'Close',
    value: 'Valor',
    user_name: "Nombre de usuario",
    view: 'Ver mas',
    dismiss: 'Dismiss',
    confirm: 'Confirm',
    download: 'Download',
    optional_mark: '(optional)',
    required_mark: '(required)',
    //form
    date_from: "Desde",
    date_to: "Hasta",
    from_date: "Desde {start, time}",
    to_date: " hasta {end, date, long}",
    goodbye: "Adios",
    customers: 'Clientes',
    patrol_licenses: 'Licencias de Patrol',
    terms: "Terms",
    privacy: "Privacy",
    copyright: "Proofpoint, Inc.",
    accounts: 'Cuentas',
    tags: 'Etiquetas',
    link: 'Enlace',
    links: 'Enlaces',
    users: 'Usuarios',
    status: 'Estado',
    prev: 'Anterior',
    next: 'Siguiente',
    pages: 'Páginas',
    select_tag: 'Seleccionar Etiqueta',
    todo_list: 'Lista de Tareas',
    under_construction: 'En Construcción',
    go_to_catalog: 'Acceder al Catalogo',
    go_to_dashboard: 'Acceder al Dashboard',
    //
    LANDING: 'Home',
    DASHBOARD:  'Dashboard',
    SOCIAL_DISCOVER: 'Social Discover',
    MOBILE_DISCOVER:  'Mobile Discover',
    DOMAIN_DISCOVER:  'Domain Discover',
    PASSWORD_LOCKBOX:  'Password Lockbox',
    TASKS:  'Tasks',

    //V1 page links
    find_accounts: 'Find Accounts',
    advanced_discover: 'Advanced Discover',
    add_accounts: 'Add Accounts',
    tag_view: 'Tag View',
    ignored_accounts: 'Ignored Accounts',
    image_library: 'Image Library',
    image_libraries: 'Image Libraries',
    find_apps: 'Find Apps',
    ignored_apps: 'Ignored Apps',
    configuration: 'Configuration',
    domain_detections: 'Domain Detections',
    domain_detections_v2: 'Domain Detections (UI-v2)',
    url_detections: 'URL Detections',
    add_watched: 'Add Watched',
    ignored_domains: 'Ignored Domains',
    alerts_v1: 'Alerts',

    entities: 'Entities',
    entities_unprotected: 'Entities Unprotected',
    entities_places: "Lugares",
    entities_people: "Persones",
    entities_brand: "Brand",
    entities_hastag: "Custom",
    profiles: 'Profiles',
    content_and_incidents: 'Content/Incidents',
    content_item: 'Content Item',
    account_admins: 'Account Admins',
    app_policies: 'App Policies',
    content_policies: 'Content Policies',
    custom_policies: 'Custom Classifiers',
    profile_policies: 'Profile Policies',

    commenters: 'Commenters',
    reports: 'Reports',
    takedowns: 'takedowns',

    //Dashboard
    no_data_available: 'Aún no hay información disponible.',
    //Dashboard Titles
    dashboard_security_title: 'Panel de Seguridad',
    dashboard_compliance_supervisor_title: 'Reviewer Dashboard',
    dashboard_compliance_title: 'Compliance Overview',
    dashboard_program_manager_title: 'Program Manager Dashboard',
    summary: 'Summary',
    dashboard: 'Panel de Control',
    dashboards: 'Paneles de Control',
    user_notifications: 'Notificaciones',
    content_classifier_audit: "Content Classifier Audit",

    high_risk_incidents: "Incidentes de Riesgo",
    pending_takedowns: "Bajas Pendientes",
    takedowns_pending: "Bajas Pendientes",
    administrative_suggestions: 'Sugerencias del Administrador',
    administrative_recommendations: 'Administrative Recommendations',
    data_coverage: "Cobertura de Datos",

    //disconnected accounts
    disconnected_accounts: "Expired Accounts",
    disconnected_accounts_modal_message: "Proofpoint cannot monitor, protect or archive data for expired accounts. You can notify your account owners to reauthorize now.",
    notify_account_owners: "NOTIFY ACCOUNT OWNERS",

    notify_account_title: "Notify Expired Account Owners",
    disconnected_accounts_message_to_dialog_users: "You have {totalDisconnectedAccounts} expired accounts. Edit the subject and message below and our system will individually email each account owner.",
    disconnected_accounts_email_intro: "Hi {leftCurlyBracket}ACCOUNT OWNER NAME{rightCurlyBracket},",
    disconnected_account_reauth_link: "Reauthorization link for {leftCurlyBracket}ACCOUNT NAME{rightCurlyBracket}: {leftCurlyBracket}REAUTHORIZATION LINK{rightCurlyBracket}",
    notify_account_button1: "DISMISS",
    notify_account_button2: "SEND NOTIFICATIONS",
    disconnected_accounts_snackbar_message: "{num_emails_sent, plural, =1 {{num_emails_sent} expired account email sent successfully.} other {{num_emails_sent} expired account emails sent successfully.}}",

    //Pending Takedown Translations, do not change unless design spec changes
    social_accounts: 'Búsqueda de Cuentas',
    domains: "Dominios",
    mobile_apps: "Aplicaciones Móviles",
    social_content: "Contenido Social",
    web_content: "URL",

    social_identity_searches:'Búsqueda Social',
    protected_assets_social_accounts: 'Social Accounts',
    domain_identity_searches: 'Búsqueda de Dominios',
    people: 'Personas',
    locations: 'Localizaciones',
    mobile_app_identity_searches: 'Búsqueda de Móvil',
    brand: 'Marca',
    brands: 'Marcas',
    custom: 'Personalización',

    policy_action_log: "Log",
    policy_action_notify: "Notify",
    policy_action_delete: "Delete",
    policy_action_hide: "Hide",

    top_incidents: "Incidentes Superiores",
    trend_classifier_groups: "Top Classifier Groups",
    incident_remediation: "Cost Savings - Automated Remediation",
    content_items_reviewed: 'Elementos de contenido revisados',
    incidents_remediated: 'Incidentes remediados',
    trend_classifiers: "Top Classifiers",

    top_overall_categories: "Principales Categorías Generales",
    top_classifier_groups: "Los Mejores Grupos Clasificadores",
    threat_trends: "Threat Thrends",
    top_threat_actors: "Actores de Alta Amenaza",
    incidents_by_entity_type: "Incidents By Entity Type",
    top_entities: "Entidades Principales",
    top_entity_types: "Tipos de Entidades Principales",
    top_risk_entities: "Entidades Principales",
    policy_action_summary: "Resumen de Acción Política",
    takedown_summary: "Resumen de Eliminación",
    top_classifiers: "Top Classifiers",
    protected_assets: "Activos Protegidos",
    automated_remediation_roi: "Remediación Automatizada ROI",
    policy_action: 'Resumen de Acción Política', //?
    policy_action_incident: "{num_incident, plural, =1 {Incident} other {Incidents} }",

    threat_center: 'Threat Center',
    discover: 'Discover',
    social_discover: 'Social Discover',
    social_discover_group_title: 'Social',
    mobile_discover: 'Mobile Discover',
    mobile_discover_group_title: 'Mobile',
    domain_discover: 'Domain Discover',
    domain_discover_group_title: 'Domain',
    common_discover_group_title: 'Common',
    patrol: 'Patrol',
    tasks: 'Tasks',
    sight: 'Sight',
    ROI: 'ROI',
    alerts: 'Alerts',
    password_lockbox: 'Password Lockbox',
    risk_scores_bundle: 'Risk Scores Bundle',
    risk_event_summary: 'Risk Event Summary',
    top_entity: 'Top Entity',

    patrol_account: 'Patrol Account',

    // Management
    management: "Gestión",
    user_management: "Usuarios",
    external_apps: "Aplicaciones Externas",
    audit_logs:  "Auditoría",

    // Admin Management
    admin_account: "My Info",
    admin_clients: "Manage Clients",
    admin_users: "Manage Users",
    admin_roles: "Role Management",
    admin_teams: "Team Management",
    admin_external_apps: "External Apps",
    admin_takedowns: "Takedown Config",
    admin_audits: "Audit Logs",

    //
    help_desk: 'Soport Técnico',
    documentation: 'Documentatión',

    user_settings: 'Mis Datos',
    sign_out: 'Salir',
    my_information: "Mis datos",
    email: "Correo Electrónico",
    locale: 'Locale',
    change_to: 'Change to',
    //Audit logs
    date: "Fecha",
    type: "Tipo",
    name: "Nombre",
    incident: "incidente",
    incidents: 'Incidentes',
    actor: "Usuario",
    details:"Detalles",

    //FilterDates Options
    last_day: 'Ultimo día',
    last_7_days: 'Últimos 7 días',
    last_15_days: 'Últimos 15 días',
    last_30_days: 'Últimos 30 días',
    last_3_months: 'Últimos 3 meses',
    last_6_months: 'Últimos 6 meses',
    last_year: 'El año pasado',
    all: 'Todo',


    property_TW: "Twitter",
    property_FB: "Facebook",
    property_IG: "Instagram",
    property_LI: "LinkedIn",
    property_SF: "Salesforce",
    property_YT: "YouTube",

    // Costs chart
    over_last_D7: 'Over Last 7 days',
    over_last_D15: 'Over Last 15 days',
    over_last_D30: 'Over Last 30 days',
    over_last_M3: 'Over Last 3 months',
    over_last_M6: 'Over Last 6 months',
    over_last_Y1: 'Over Last year',
    over_last_ALL: 'Over All Time',

    //Risks
    risk_0: 'High',
    risk_1: 'Medium',
    risk_2: 'Low',

    //security dash
    log: 'Registros de Datos',
    notify: 'Notificar',
    hide: 'Esconder',
    delete: 'Borrar',
    successful: 'Exitoso',
    failed: 'Fallado',
    pending: 'Pendiente',
    remediated_incidents: 'Incidentes Remediados',
    cost_savings: 'Ahorro de Costes (USD)',
    vs_last_30_days: 'vs últimos 30 días',
    apps: 'Aplicaciones',
    social: 'Social',
    criminal: 'Criminal',
    abnormal: 'Anormal',
    security: 'Seguridad',
    risk: 'Riesgo',
    time: 'Hora',
    entity: 'Entidad',
    source: 'Fuente',
    threat_actor: 'Actor de Amenaza',
    threat_source: 'Threat Source',
    threat_category: 'Categoría de Amenaza',
    classification: 'Clasificación',
    entity_type: 'Tipo de Entidad',
    account: 'Cuenta',
    place: 'Ubicaciones',
    security_and_spam: 'Seguridad y Spam',
    impersonation: 'Impersonation', //?
    impersonations: 'Impersonations', //?
    //data coverage
    //titles
    data_coverage_title_social_account_network_search: 'Social Accounts - Network Search',
    data_coverage_title_protected_social_accounts: 'Protected Social Accounts',
    data_coverage_title_whois_domains: 'WhoisDomains',
    data_coverage_title_web_darknet: 'Web/DarkNet Content',
    data_coverage_title_breach_database: 'Breach Database',
    data_coverage_title_mobile_apps_store_search: 'Mobile Apps - Store Search',
    data_coverage_title_twitter: 'Twitter',
    data_coverage_title_other: 'Other',
    //units
    data_coverage_units_social_account_network_search: 'posts',
    data_coverage_units_protected_social_accounts: 'posts',
    data_coverage_units_whois_domains: 'domains',
    data_coverage_units_web_darknet: 'documents',
    data_coverage_units_breach_database: 'records',
    data_coverage_units_mobile_apps_store_search: 'apps',
    data_coverage_units_twitter: 'tweets',
    data_coverage_units_other: 'records',


    //pod actions
    pod_action_move: 'Move Widget',
    pod_action_delete: 'Remove Widget',
    pod_action_edit: 'Edit Widget',

    //widgets
    widgets_selected: "Widgets Seleccionados",
    selected: "Selected",
    selection_options: "Selection Options",
    dashboard_widgets: "Widgets de Dashboard",
    EDIT_LAYOUT: "Editar Diseño",
    SAVE: "SALVAR",
    CANCEL: "CANCELAR",

    // Content classifier audit app
    review_auditor: "Auditor",
    classifier_audit_report_done_title: "Audit: ",
    classifier_audit_report: "Audit Report",
    auditor_item_missing_classifications: "Missing Classifications",
    classifier_audit_modal_classifier_selection_message: "Should not trigger any policies",
    auditor_add_note: "Add Note",

    // Patrol proxy access policies app
    proxy_access_policy_title: "Access Policies",
    proxy_access_policy_subtitle: "Access Policy: ",
    create_new_policy: "Create New Policy",
    facebook_rules: "Facebook",
    rule_name: "Rule Name",
    rule_status: "Status",
    policy_name: "Policy Name",
    policy_description: "Policy Description",
    policy_users: "Accounts using Policy",
    last_updated: "Last Modified",
    create_policy_dialog_title: "Create New Access Policy",
    edit_policy_dialog_title: "Edit Access Policy",
    create_policy_dialog_create: "Create",
    create_policy_dialog_continue: "Continue",
    create_policy_dialog_edit: "Edit",
    policy_dialog_cancel: "Cancel",
    save_policy: "Save Changes",
    discard: "Discard Changes",
    recommended_action: "Recommended Action",
    rule_content_type: "Content Type",
    compliance_consideration: "Compliance Consideration",
    rule_classification: "Classification",
    allow_rule: "Allow",
    block_rule: "Block",
    policy_name_default: "Enter Policy Name",
    policy_description_default: "Enter Policy Description",
    delete_access_policy: "Delete Policy",
    disable_toolbar: "Disable Toolbar",
    enable_toolbar: "Enable Toolbar",
    add_link: "Add Link",
    delete_policy_warning: "Are you sure you want to delete this policy? This action CANNOT be undone.",
    delete_policy_confirmation: "Delete Policy Confirmation",
    policy_under_use: "This policy is being used by one or more accounts and cannot be deleted.",
    policy_defaults_error: "There are errors on the Policy Defaults tab.",
    export_accounts_list: "Export List of Accounts",
    no_accounts: "This policy has no accounts to list",

    incidents_list: "Content",
    submitted_by: "Submitted By",
    submitted_via: "Submitted Via",
    author_name: "Author Name",
    breached_domain: "Breached Domain",
    affected_entity: "Affected Entity",
    applied_action: "Applied Action",
    recipient_name: "Recipient Name",
    policy_violations: "Policy Matches",
    informational_classifications: "Informational Classifications",
    detected_at: "Detected At",
    crawled_on: "Crawled On",
    posted_at: "Posted At",
    submitted_at: "Submission Date",
    scheduled_for: "Scheduled For",
    content_type: "Content Type",
    content: "Content",
    categories: "Categorías",
    show_conversation: "Show Conversation",
    hide_conversation: "Hide Conversation",

    assign_to: "Assign To",
    assign_to_me: "Assign to Me",
    unassign: "Unassign",
    task_unassigned: "Unassigned",
    assign_task: "Assign Task",
    unassign_task: "Unassign Task",

    date_archived: "Date Archived",
    date_purged: "Purge Date",
    author_emails: "Author Email(s)",
    app_name: "Posted Via",
    incident_links: "Links",
    task_assignee: "Assignee",
    workflow_status: "Workflow Status",
    applied_actions: "Applied Action(s)",
    prescribed_actions: "Prescribed Action(s)",

    extracted: "Extracted",
    video_image: "Video Image",
    image: "Image",

    task_id: "Task ID",

    //Content classifier audit app table
    classifier_audit_table_audit_name: 'Audit Name',
    classifier_audit_table_created_by: 'Created By',
    classifier_audit_table_date_created: 'Date Created',
    classifier_audit_table_sample_size: 'Sample Size',
    classifier_audit_table_status: 'Status',
    classifier_audit_table_null: 'Null',
    classifier_audit_table_completed: 'Completed',
    classifier_audit_table_in_progress: 'In Progress',
    classifier_audit_table_audit: 'Audit ',

    create_new_audit: "Create Audit",
    export_results_to_csv_action: "Export Results to CSV",
    export_results_to_pdf_action: "Export Results to PDF",
    cr_view_results: "View Results",
    continue_cr_action: "Continue Audit",
    rename_cr_title: "Rename Audit",
    remove_cr_action: "Delete Audit",

    //classifier audit report form error messages
    review_audit_error_message_audit_title: "You must enter an audit name",
    review_audit_error_message_date_range: "You must select one date range period",
    review_audit_error_message_content_sources: "You must select at least one content source category",
    review_audit_error_message_item_scope: "You must select one item scope preference",
    review_audit_error_message_content_types: "You must select at least one content type",
    review_audit_error_message_author_type: "You must select at least one author type",
    review_audit_error_message_activity_type: "You must select at least one activity type",
    review_audit_error_message_percentage: "Sample percentage must be greater than 0 and less than or equal to 100",
    review_audit_error_message_content_classifications: "You must select at least one classification",
    review_audit_error_message_staff_reviewed_members: "You must select at least one team",

    //classifier audit report selections
    create_review_audit: "Create Audit",
    create_review_enter_name: "Enter Name",
    create_review_audit_name: "Audit Name (required)",
    create_review_audit_date_range: "Date Range (required)",
    create_review_audit_content_source: "Source (required)",
    create_review_audit_items_in_audit: "Items in Audit Scope (required)",
    create_review_audit_content_type: "Content Type",
    create_review_audit_activity_by: "Activity By (required)",
    create_review_audit_tags: "Tags",
    create_review_audit_activity_type: "Activity Type (required)",
    create_review_audit_content_activity_scope: "Content Activity Scope (required)",
    create_review_audit_sample_percentage: "Sample Percentage (required)",
    create_review_audit_sample_size: "Sample Size",
    auditor_sample_max_per_reviewer: "Max Number Of items Per Reviewer",
    create_review_audit_footer: "This is the number of content items included in this audit.",
    create_review_audit_reviewer_footer: "Enter the max number of items per reviewer to be generated",
    create_review_audit_percent_footer: "You may enter decimal %, e.g. .001 and up to 100",
    create_review: "Create Audit",
    create_review_select_one: "Select One",
    create_review_select_one_or_more: "Select one or more",
    create_review_search: "Type in to search",
    auditor_mark_as_correct: "Mark as Correct",
    auditor_mark_as_incorrect: "Mark as Incorrect",

    classifier_audit_report_triggered_compliance_classifiers: "Triggered Compliance Classifiers",
    classifier_audit_report_did_not_trigger_compliance_classifiers: "Did Not Trigger Compliance Classifiers",
    classifier_audit_report_include_all_items: "All Items",
    classifier_audit_report_staff_reviewed_items: "Staff Reviewed Items",
    classifier_audit_report_system_approved_items: "System Approved Items",
    review_audit_content_classifications: "Triggered specific classifiers...",
    review_audit_select_classifiers: "Select classifiers",
    review_audit_select_teams: "Select teams",
    classifier_audit_report_brand: "Account",
    classifier_audit_report_commenter: "Third-Party",
    classifier_audit_report_brand_last_month: "Last Month",
    classifier_audit_report_brand_last_quarter: "Last Quarter",
    classifier_audit_report_brand_last_year: "Last Year",
    classifier_audit_report_brand_all_time: "All Time",
    classifier_audit_summary_of_results: "This audit has been completed.",
    classifier_audit_detailed_results: "Detailed Results:",
    classifier_audit_summary: "{correct, total, percent, plural, =0 {{correct} out of {total} content item classifications marked as 'Correct.' The {total} content item sample has the following attributes: } other {{correct} out of {total} content item classifications marked as 'Correct': {percent}% classification accuracy. The {total} content item sample has the following attributes:} }",
    review_audit_type_comments: "Comments",
    review_audit_type_direct_messages: "Direct Messages",
    review_audit_type_posts: "Posts",
    review_audit_type_reactions: "Reactions",
    review_audit_all_activity_types: "(4) Comments, Direct Messages, Posts, Reactions",
    review_audit_content_type_submitted_content : "Submitted Content",
    review_audit_content_type_captured_content : "Captured Content",

    delete_classifier_review: "Delete Audit",
    remove_classifier_review_description: "Are you sure you want to delete this audit? This action cannot be undone.",
    classifier_review_removed_msg: "The classifier review has been removed successfully",
    classifier_review_csv_export_description: "This export includes a large number of audit items and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
    review_audit_creating_audit: "Creating Audit",
    review_audit_items_generating: "Generating the sample of items based on your filter criteria. This process may take a few moments, depending on the size of the sample.",
    review_audit_error_message: "There was an error while trying to create your audit",
    rename_audit: "Rename Audit",
    audit_name_label: "Audit Name (required)",
    classifier_review_title_updated_msg: "The classifier review {title} title has been updated successfully",
    cr_item_could_not_load: "Item could not be loaded",
    cr_skip_to_next_item: "Skip to Next Item?",
    cr_loading: "Loading ...",
    audit_results_summary: "Audit Results Summary",
    audit_summary_correct: "Marked Correct",
    audit_summary_incorrect: "Marked Incorrect",
    audit_summary_audit_name: "Audit Name: ",
    audit_summary_conducted_by: "Conducted By: ",
    audit_summary_completed_on: "Completed On: ",
    audit_summary_total_reviewed: "Total number of items reviewed: ",
    audit_summary_total_correct: "Total number of items marked correct: ",
    audit_summary_total_incorrect: "Total number of items marked incorrect: ",
    audit_results_summary_chart: "{item_count, plural, =1 {{item_count} Reviewed Item} other {{item_count} Reviewed Items}}",
    audit_results_chart_subtitle: "{item_count, plural, =1 {Reviewed Item} other {Reviewed Items}}",
    audit_summary_view_audit_settings: "View Audit Settings",
    audit_summary_audit_settings: "Audit Settings",
    close_audit_summary_dialog: "Close",
    audit_summary_dialog_audit_name: "Audit Name (required)",
    audit_summary_dialog_date_range: "Date Range (required)",
    audit_summary_dialog_content_source: "Source (required)",
    audit_summary_dialog_policy_match: "Items in Audit Scope (required)",
    audit_summary_dialog_content_direction: "Activity By (required)",
    audit_summary_dialog_activity_type: "Activity Type (required)",
    audit_summary_dialog_tags: "Tags",
    audit_summary_no_tags_selected: "No tags selected",
    audit_summary_dialog_percentage: "Sample Percentage (required)",
    audit_summary_dialog_sample_size: "Sample Size",
    audit_summary_dialog_size_note: "This is the number of content items included in this audit.",
    cr_completed_badge: "Completed",
    cr_wait_status: "Your sample size is being generated. Please try again later.",
    cr_summary_FB: "Facebook",
    cr_summary_TW: "Twitter",
    cr_summary_IG: "Instagram",
    cr_summary_YT: "YouTube",
    cr_summary_LI: "LinkedIn",
    cr_summary_brand: "Account",
    cr_summary_commenter: "Third-Party",
    cr_summary_correct: "Correct",
    cr_summary_incorrect: "Incorrect",
    cr_summary_item: "Item ",

    // Items
    timestamp: "Timestamp",
    //actor: "Actor",
    action: "Action",
    activity_note: "Note",
    review_code: "Review Code",
    author: "Author",
    at: "at",
    by: "by",
    patrol_incidents_table: "Patrol > Content / Incidents",
    patrol_content_item: "Patrol > Content Item",
    item_type: "Type",
    actions: "Action(s) Taken",
    permalink: "Source Link",
    view_on: "View on",
    extracted_images: "Extracted Images",
    extracted_video_images: "Extracted Video Images",
    extracted_article_content: "Extracted Article Content",
    item_identifier: "Identifier",
    video_image_timestamp: "Video Image Timestamp",
    video_transcript: "Full Video Transcript",
    item_id_ghost: "Item Identifier",
    ocr_text: "Extracted OCR Text",

    raw_content: "Raw Content",
    matching_credit_card_numbers: "Matching Credit Card Numbers",
    download_matching_credit_card_numbers: "Download Matching Credit Card Numbers",
    download_email_addresses: "Download Email Addresses",
    download_content: "Download Content",
    approve_item: "Approve Item",
    approve_and_forward_item: "Approve & Forward Item",
    reject_item: "Reject Item",
    reject_and_forward_item: "Reject & Forward Item",
    forward_item: "Forward Item",
    close_item: "Close Item",

    more_actions: "More Actions",

    supervisor: "Reviewer",

    task_type_Item: "Content Post Publish",
    task_type_SubmittedContentItem: "Content Pre Publish",
    task_type_ReviewProfileChange: "Profile Change",
    task_type_ReviewProfileFullPrereview : "Full Pre Review",
    task_type_ReviewProfileFullExpirationReview : "Full Expiration Review",
    task_type_ReviewProfileExpiration : "Profile Expired",
    task_type_ReviewProfilePostReview : "Post Review",
    task_type_ReviewProfilePrereview: "Pre Review",

    edit_notes: "Edit Notes for {object_name}",
    reviewer_notes: "Reviewer Notes",
    add_new_note: "Add New Note",
    add_note: "Add Note",
    edit_note: "Edit Note",
    remove_note: "Remove Note",
    remove_note_text: "Are you sure you want to remove this note?",
    note: "Note",
    notes: "Notes",
    reviewer_code: "Reviewer Code",
    reviewer: "Reviewer",
    reviewer_date: "Date",
    recipient: "Recipient",

    select_users_placeholder: "Select User(s)",
    select_teams_placeholder: "Select Team(s)",
    additional_emails: "Additional Emails",
    emails: "Emails",
    copy_account_owner: "Copy account owner(s)",

    additional_emails_placeholder: "Enter a list of emails separated by commas",
    share_subject_placeholder: "{username} Has Shared Digital Risk Content With You",

    reviewer_placeholder: "Select Reviewer",
    reviewer_required: "Please select a reviewer",
    reviewer_code_error: "Reviewer Code must not exceed 128 characters",

    items_action_title_APPROVE: "Approve Content",
    items_action_text_APPROVE: "Are you sure you want to approve this item?",
    items_action_confirm_APPROVE: "Approve Content",

    items_action_title_APPROVE_AND_FORWARD: "Approve and Forward Content",
    items_action_text_APPROVE_AND_FORWARD: "Are you sure you want to approve this item?",
    items_action_confirm_APPROVE_AND_FORWARD: "Approve and Forward Content",

    items_action_title_MARK_REVIEWED: 'Mark Content Reviewed',
    items_action_text_MARK_REVIEWED: "Are you sure you want to mark this item reviewed?",
    items_action_confirm_MARK_REVIEWED: "Mark Content Reviewed",

    items_action_title_REJECT: "Reject Content",
    items_action_text_REJECT: "Are you sure you want to reject this content?",
    items_action_confirm_REJECT: "Reject Content",

    items_action_title_REJECT_AND_REMOVE: "Reject and Remove Content",
    items_action_text_REJECT_AND_REMOVE: "Are you sure you want to reject and remove this content?",
    items_action_confirm_REJECT_AND_REMOVE: "Reject and Remove Content",

    items_action_title_FORWARD: "Forward Content",
    items_action_text_FORWARD: "Please select the reviewer you would like to receive this task.",
    items_action_confirm_FORWARD: "Forward Content",

    items_action_title_PERMANENTLY_MASK_CONTENT: "Permanently Mask Content",
    items_action_text_PERMANENTLY_MASK_CONTENT: "WARNING: You are about to permanently mask this item's content. This action cannot be reversed.",
    items_action_confirm_PERMANENTLY_MASK_CONTENT: "Confirm",
    permanently_masked_content_text: "This item's content has been permanently masked. Please see the item's notes.",
    permanently_already_masked_content: "This item's content was already permanently masked",

    items_action_title_REJECT_AND_FORWARD: "Reject & Forward Content",
    items_action_text_REJECT_AND_FORWARD: "Please select the reviewer you would like to receive this task.",
    items_action_confirm_REJECT_AND_FORWARD: "Reject & Forward Content",

    items_action_title_CLOSE: "Close Task",
    items_action_text_CLOSE: "Are you sure you want to close this task?",
    items_action_confirm_CLOSE: "Close Task",

    filter_title_task_type_filter: "Task Types",

    task_type_filter_APPROVAL: "Content",
    task_type_filter_PROFILE_LOCK_REVIEW: "Profiles",

    no_task_selected: "There is no content available to review.",
    unable_to_retrieve_task: "Unable to load information for this task.",

    try_to_remediate: "Remove this content from the social network where it was posted (Remediate).",

    task_table_type: "Type",
    task_table_account: "Account",
    task_table_created_at: "Opened at",
    task_table_days_opened: "Days open",
    task_table_days_action: "Action",

    // Domains
    domain: "Domain",
    change_detected: "Change Detected",
    date_changed: "Date Changed",
    seed: "Seed",
    detections: "Detections",
    remaining_seeds: "All Other Seeds",

    detection_date: "Detection Date",
    tap_categories: "TAP Categories",
    remaining_classifications: "All Other Classifications",

    add_to_pps_block_list: "Add to PPS Block List",
    remove_from_pps_block_list: "Remove from PPS Block List",
    add_to_fraud_classifier: "Add to Patrol Watch/Block List",
    remove_from_fraud_classifier: "Remove from Patrol Watch/Block List",
    change_classification: "Change Classification",
    export_to_csv: 'Export to CSV',
    export_pps_block_list: 'Export PPS Block List',

    schedule_csv_export: 'Schedule CSV Export',
    title: 'Title',
    email_recipient: 'Email Recipient',
    schedule: 'Schedule',
    run: 'Run',
    start_on: 'Start on',
    every: 'Every',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    week: 'Week',
    weeks: 'Weeks',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',

    enter_title: "Enter title",
    enter_email_address: "Enter email address",

    schedule_csv_export_created: 'The report has been created',

    report_title_missing_validation_message: "Report title is required.",
    schedule_week_missing_validation_message: "Weekly settings are required.",
    schedule_period_missing_validation_message: "Please select a period.",
    email_recipient_missing_validation_message: "Email recipient is required.",
    scheduled_email_validation_message: "Please enter a valid email. '{rejected_email}' is not allowed.",

    warning: "Warning",
    reason_required: "Reason (required)",
    reason_error: "You must record a reason for this action (500 characters max).",
    reason_hint: "You must record a reason for this action (500 characters max).",
    warning_permanently_mask_content: "You are about to permanently mask this item's content. This action cannot be reversed.",

    domains_action_title_change_classification: 'Change Classification',
    domains_action_title_view_takedown: 'View Takedown',
    domains_takedown_title_create: 'Report for Takedown',
    domains_takedown_title_view: 'View Takedown',
    dialog_title_for: ' for {object_name}',

    //Change Classification
    domains_current_classifications: 'Current classifications:',
    domains_new_classification: 'New classification',
    domains_update_tags_upon_change: 'Update tags upon change',

    domain_ignored_message: "'{url}' has been ignored.",
    domain_batch_ignored_message: "The selected domains have been ignored.",
    domain_batch_unignored_message: "The selected domains have been unignored.",
    domain_unignored_message: "'{url}' has been unignored.",
    domain_added_to_pps_block_list: "'{url}' has been added to PPS Block List.",
    domain_removed_from_pps_block_list: "'{url}' has been removed from PPS Block List.",
    domain_added_to_fraud_classifier: "'{url}' has been added to Patrol Watch/Block List.",
    domain_removed_from_fraud_classifier: "'{url}' has been removed from Patrol Watch/Block List.",
    domain_classification_changed: "Classification changed from '{from}' to '{to}'.",
    batch_domain_classification_changed: "Classification changed to '{to}' for the selected elements.",

    domain_select_classification_default: 'Select a classification...',

    domain_screenshot: "Domain Screenshot",

    //DOMAIN TAKEDOWNS
    takedown_send_email: "Send via Email",
    takedown_download_package: "Download Package",
    view_takedown: 'View Takedown',
    create_takedown: 'Report for Takedown',
    takedown_domain: 'Takedown Domain',
    destination: 'Destination',
	reason: 'Reason',
    domain_seeds: 'Domain Seed',
    affected_domain: 'Affected Domain',
    keyword: "Keyword",
    note_for_vendor: "Notes for Destination",
    internal_note: "Internal Notes",
    add_internal_note: "Add Internal Notes",
    add_note_for_vendor: "Add Notes for Destination",
    request_id: "Request ID",
    date_remediated: "Date Remediated",
    //date_submitted: "Date Submitted",
    takedown_status: "Case Status",
    resolution_status: "Resolution Status",
    assigned_analyst: "Assigned Analyst",
    destination_notes: "Destination Notes",
    takedown_completed_date: "Completed Date",
    upload_evidence: "Upload Evidence",
    uploaded_evidence: "Uploaded Evidence",
    evidence_footer_1: "Max upload: 20 files (10 MB total)",
    evidence_footer_2: "Supported filetypes: .bmp, .png, .jpg, .eml, .txt",
    submit_takedown_message: "Takedown has been submitted successfully",
    close_takedown_message: "Takedown has been closed successfully",
    close_takedown_reason: "Resolution",
    close_takedown_reason_success: "Takedown Successful",
    close_takedown_reason_unsuccess: "Takedown Unsuccessful",
    close_takedown_reason_other: "Other",
    close_takedown: "Close Takedown",
    download_package: "Download Package",
    download_email_file: "Download Email File",
    download_file_body_message: "Please click below to download your file",
    need_more_info: 'Need More Info?',
    add_files: "Add Files",
    error_evidence_files_message: "Evidence files must be successfully uploaded before submitting the Takedown",
    error_long_notes_for_vendor_message: "The note is over the 1,500 limit. Longer notes may be uploaded as evidence.",
    error_long_internal_notes_message: "The note is over the 1,500 limit. Please enter a shorter note and try again.",

    generic_error: "There was an error while trying to perform the operation. Please refresh the page and try again. If the problem persist contact an administrator.",

    submit_takedown_error_message: "There was an error while trying to submit the Takedown",
    close_takedown_error_message: "There was an error while trying to submit the Takedown",
    vendor_missing_validation_message: "Please select a destination option for the takedown",
    reason_missing_validation_message: "Please provide a reason for the takedown",
    resolution_missing_validation_message: "Please provide a resolution for closing the takedown",
    seed_required_validation_message: "Domain Seed is required",
    seed_format_validation_message: "Please enter a valid seed (e.g.): example.com",
    contact_email_address_required_validation_message: "Contact Email Address is required",
    add_notes_for_vendor_required_validation_message: "Add Notes for Destination is required",


    filter_title_classifications: "Classifications",
    select_classifications: "Select Classification",

    filter_title_policy_actions: "Policy Actions",
    select_policy_actions: "Select Policy Action",

    copy_link_to_clipboard: 'Copy Link to Clipboard',

    pod_filters_options: "Pod Filters Options",

    select_all_options: "Select All",

    accounts_summary: "Accounts Summary",
    active_accounts: "Active Accounts",
    inactive_accounts: "Expired Accounts",

    profiles_summary: "Profiles Summary",
    onboarding_profiles: "Onboarding",
    expired_profiles: "Expired",
    incremental_profiles: "Incremental",
    pending_reviews: "Pending Reviews",
    top_changed_fields: "Top Changed Fields",
    profiles_column_platform: "Platform",
    profiles_column_field: "Field",
    profiles_column_count: "Count (% of Total)",
    profiles_column_rejected: "Rejected",
    profiles_column_approved: "Approved",
    activity_30: "Activity over last 30 days",

    content_summary: "Content Summary",
    pre_published_review: "Pre Publish Review",
    post_published_review: "Post Publish Review",
    unreviewed: "Unreviewed",
    approved: "Approved",
    rejected: "Rejected",
    top_rejection_categories: "Top Rejection Categories",
    rejection_category: "Rejection Category",
    select_patrol_policies: "Content Policies",
    select_node_content_types: "Node Content Types",
    select_profile_policies: "Profile Policies",

    program_manager: "Program Manager",

    not_allowed_pod: "Not available for links shared outside your client.",

    //DOMAIN ALERTS
    alert_name: 'Alert Name',
    alert_type: 'Alert Type',
    date_created: 'Date Created',
    date_last_modified: 'Date Last Modified',
    notifications: 'Notifications',

    create_new_alert: 'Create New Alert',

    alert_type_state_change: 'State Change',
    alert_type_new_registration: 'New Detection',
    alert_type_new_detection: 'Classification Change',
    alert_type_tag_change: 'Tag Change',
    alert_type_matches_view: 'Matches View',
    alert_type_expiration: 'Expiration',

    create_alert: 'Create New Alert',

    remove_domain_alert_dialog_title: "Delete Domain Alert",
    remove_domain_alert_dialog_text: "Are you sure you wish to delete the domain alert: '{name}'? This action cannot be undone.",
    domain_alert_removed_message: "'{name}' has been deleted.",

    domain_alert_action_remove: 'Delete',

    domain_alert_details_title: 'Domain Alert Details',
    domain_alert_create_title: 'Create New Alert',

    domain_alert_name: 'Alert Name (required)',
    domain_alert_frequency: 'Frequency',
    domain_alert_rules_title: 'Alert Rules (at least one required)',
    domain_alert_events_title: 'Events (at least one required)',
    domain_alert_tag_changes: 'Alert Tag Changes (at least one required)',
    domain_alert_reminders_title: 'Reminder Frequency (required)',
    domain_alert_notifications_title: 'Send notifications to these people/teams (at least one required)',

    domain_alert_add_rule: 'Add Alert Rule',
    domain_alert_add_reminder: 'Add Reminder (required)',
    create_at_least_one_rule: 'You must create at least one rule for this alert',
    create_at_least_one_reminder: 'You must create at least one reminder for this alert',
    select_at_least_one_event: 'You must select at least one event for this alert',
    select_at_least_one_tag_change: 'You must choose at least one tag change',
    domain_alert_rule_already_exists_text: 'The rule already exists for this configuration',

    select_alert_frequency: 'Select Alert Frequency',
    saved_view: 'Saved View (required)',
    select_a_saved_view: 'You must select a saved view',
    domain_alert_associated_tag: 'Filter Tag(s) (required)',
    select_an_associated_tag: 'You must select at least one fiter tag',
    filter_tags: 'Filter Tag(s)',
    domain_alert_select_tags: 'Select Tag(s)',
    domain_alert_tags_added: 'Tag(s) Added',
    domain_alert_tags_removed: 'Tag(s) Removed',

    domain_state: 'State',
    domain_from_state: 'From State (required)',
    domain_to_state: 'To State (required)',
    domain_classification: 'Classification (required)',
    domain_state_change:'State Change (required)',
    select_domain_classification: "You must select a classification",
    domain_alert_state: "Domain State",
    domain_alert_mx_record_added: 'MX record added',
    domain_alert_ssl_installed: 'SSL installed',
    domain_alert_email_activity_detected: 'Email activity detected',
    domain_alert_ssl_expiry: 'SSL certificate expiration',
    domain_alert_domain_expiry: 'Registration expiration',
    select_from_dropdown: 'Select from dropdown',

    field_must_be_selected: "'{field}' must be selected",
    domain_alert_equal_states: 'From State and To State cannot be equal',
    domain_alert_state_change: 'You Must Select a State Change',
    domain_alert_provide_a_name: 'You must provide a name for this alert',
    domain_alert_invalid_name: 'The Alert Name only allows alphanumeric characters, spaces and parenthesis',

    alert: 'Alert',

    domain_alert_saved_message: "Alert '{name}' has been saved.",

    //NOTIFICATIONS
    notification_users: 'User(s)',
    notification_teams: 'Team(s)',
    notification_additional_emails: 'Additional Emails',
    notification_input_required_message: 'Please ensure you have entered at least one user, team or email address',
    notification_email_validation_message: 'Please ensure you have entered correctly formatted email addresses, separated by commas',

    //Share Content
    selected_users: 'Selected User(s)',
    selected_teams: 'Selected Team(s)',

    //ROVER
    rover: 'Rover',
    rover_projects: 'Rover Projects',
    rover_settings: 'Rover Settings',
    rover_project_tabs: 'UNUSED',

    //SYNDICATE
    syndicate: 'Syndicate',
    syndicate_content: 'Content',
    syndicate_config: 'Configuration',
    syndicate_users: 'Manage Users',
    syndicate_feeds: 'Content Feeds',

    //TASKS
    user_tasks: 'Tasks',

    //LEGAL FOOTER
    legal_footer: 'Legal Footer',

    syndicate_post: "Curator Submission",

    support: 'Support',
    support_portal: 'Support Portal',

    //DOMAIN DETAILS
    domain_discover_details: "Domain Discover Details",
    domain_details_title: "Domain Details: ",

    web_presence: "Web Presence",
    ip_addresses: "IP Addresses & Other Domains",
    detection_metadata: "Detection Metadata",

    final_redirected_ip_address: "Final Redirected IP Address",
    http_status_code: "HTTP Status Code",
    https_status_code: "HTTPS Status Code",
    web_title: "Web Title",
    favicon: "Favicon",
    tranco_score: "TRANCO Score",
    screenshots: "Screenshots",
    ip_address: "IP Address",
    domain_count: "Domain Count",
    domain_list: "Domains",
    domain_tags: "Tags",

    hunt_name: "Hunt Name",
    classifications: "Classifications",
    first_detected: "First Detected",
    last_detected: "Last Detected",
    contains_homoglyph: "Has Homoglyph",
    not_available: "N/A",

    ssl_certificate_information: "SSL Certificate Information",
    subject: "Subject",
    issuer: "Issuer",
    dns_names: "DNS Names",
    subject_alt_name_dns: "Subject Alt. Name DNS",
    version: "Version",
    serial_number: "Serial Number",
    ocsp: "OCSP",
    issuing_certificate_url: "Issuing Certificate URL",
    ca_issuers: "CA Issuers",
    crl_distribution_points: "CRL Distribution Points",
    subject_key_id: "Subject Key ID",
    authority_key_id: "Authority Key ID",
    not_valid_before: "Not Valid Before",
    not_valid_after: "Not Valid After",
    country_name: "Country Name",
    state_or_province_name: "State or Province Name",
    locality_name: "Locality Name",
    organization_name: "Organization Name",
    organizational_unit: "Organizational Unit",
    common_name: "Common Name",

    domain_notes: "Domain Notes",

    domain_whois_record: "Domain WHOIS Record",

    registrar_name: "Registrar Name",
    registrar_ianaid: "Registrar IANAID",
    contact_email: "Contact Email",
    whois_server: "WHOIS Server",
    nameservers: "Nameservers",
    created_date: "Created Date",
    updated_date: "Updated Date",
    expires_date: "Expires Date",
    registrant_email: "Registrant Email",
    registrant_name: "Registrant Name",
    registrant_organization: "Registrant Organization",
    registrant_street: "Registrant Street",
    registrant_city: "Registrant City",
    registrant_state: "Registrant State",
    registrant_country: "Registrant Country",
    administrative_contact_email: "Administrative Contact Email",
    administrative_contact_name: "Administrative Contact Name",
    administrative_contact_organization: "Administrative Contact Organization",
    administrative_contact_street: "Administrative Contact Street",
    administrative_contact_state: "Administrative Contact State",
    administrative_contact_city: "Administrative Contact City",
    administrative_contact_country: "Country",

    asn_information: "ASN",
    asn: "ASN",
    network: "Network",
    owner: "Owner",

    dns_information: "DNS Information",
    ipv4_addresses: 'IPV4 Addresses',
    //mx_record: 'MX Record',
    soa_record: 'SOA Record',
    spf_record: 'SPF Record',
    txt_record: 'TXT Record',

    email_telemetry: "Email Telemetry",
    count: "Count",

    tap_detections: "TAP Detections",

    domain_discover_title: "Domain Discover",

    //COMMON - Actions
    ignore: 'Ignore',
    unignore: 'Unignore',
    create: 'Create',
    edit: 'Edit',

    domain_name: "Domain Name",
    registrar: "Registrar",
    seeds_formatted: "Seeds",
    country: "Country",
    mx_record: "MX Record",
    name_servers_formatted: "Name Servers",
    tap_integration: "Has TAP",
    state_formatted: "State",
    web_state_formatted: "HTTP Status Code",
    date_submitted: "Date Submitted",
    ssl_expiry: "HTTPS",
    domain_expiry: "Expires on",
    registered_date: "Registered Date",
    oldest_tag_added_on: "Oldest Tag added on",
    newest_tag_added_on: "Latest Tag added on",
    first_detect_date: "Detected Date",
    has_telemetry: "Has Telemetry",
    special_attributes: "Special Attributes",
    registrant_email_address: "Registrant Email",
    display_only: "Display Only",
    channels: "Channels",
    ignored_on: "Ignored On",
    ignored_by: "Ignored By",

    domain_special_attributes_is_watched_tooltip: "Watched Domain",
    domain_special_attributes_is_blocked_tooltip: "Added to PPS Block List",
    domain_special_attributes_brand_fraud_tooltip: "Added to Patrol Watch/Block List",
    ignored_domain_table_unignore_action: "Unignore Domain",

    yes: "Yes",
    no: "No",

    minutes: 'minutes',
    hours: 'hours',
    days: 'days',

    filters_including: 'Including',
    filters_excluding: 'Excluding',
    filters_starts_with: 'Must begin with the term',
    filters_ends_with: 'Must end with the term',
    filters_only_mx: 'Entries with MX records ',
    filters_only_idn: 'IDN detections ',
    filters_only_watched: 'Manually entered watched domains',
    filters_only_ssl: 'HTTPS Detections ',
    filters_only_image: 'Entries with brand logos detected',
    filters_only_tap: 'Detections with TAP Details',
    filters_only_with_title: 'Detections with title',
    filters_only_under_construction: 'Ignore under construction and holding pages',
    filters_current_title_filter: 'Including in Title',
    filters_current_title_filter_exclude: 'Excluding in Title',

    blank_filter_option: '(Blanks)',

    panel_columns: 'Columns',
    panel_filters: 'Filters',
    panel_charts: 'Charts',

    domain_charts: 'Charts',
    domain_detections_by_classification: 'Detections by Classification',
    domain_detections_by_tag_name: 'Detections by Tag Name',

    domain_action_ignore: 'Ignore',
    domain_action_report_for_takedown: 'Report for Takedown',
    domain_action_add_to_pps_block_list: 'Add to PPS Block List',
    domain_action_remove_from_pps_block_list: 'Remove from PPS Block List',
    domain_action_add_to_domain_fraud: 'Add to Patrol Watch/Block List',
    domain_action_remove_from_to_domain_fraud: 'Remove from Patrol Watch/Block List',
    domain_action_edit_notes: 'Edit Notes',
    domain_action_change_classification: 'Change Classification',
    domain_action_expiration_alerts: 'Expiration Alerts',
    domain_action_edit_tags: 'Edit Tags',
    domain_action_unwatch_domain: 'Unwatch Domain',

    ignore_domain_dialog_title: "Ignore Domain",
    ignore_domain_dialog_text: "Are you sure you wish to ignore the domain: '{url}'?",
    ignore_takedown_domain_dialog_text: "This operation will close the associated pending Takedown.",

    ignore_batch_domain_dialog_title: "Ignore Domains",
    ignore_batch_domain_dialog_text: "Are you sure you wish to ignore the selected domains? Any pending takedowns associated with these domains will be closed.",

    ignore_domains_modal: "Ignore Domains",
    add_ignored_domains_title: "Add Ignored Domains",
    add_domains_to_ignore: "Add Domains to Ignore",
    add_ignore_list_placeholder: "Enter one domain per line",
    add_ignored_classification: "Select Classification (optional):",
    add_ignored_classification_placeholder: "Select Classification",
    add_ignored_tags: "Select one or more tags to apply (optional):",
    add_ignored_tags_placeholder: "Select Tags",
    add_ignored_results_modal_title: "Add Ignored Domains - Summary",

    ignored_validation_empty: "Please enter at least one domain to look up",
    ignored_validation_invalid: "Please enter a valid domain (e.g.): example.com",

    ignored_msg_invalid: "The domain can not be parsed or its invalid.",
    ignored_msg_duplicated: "The domain was previously ignored.",
    ignored_msg_is_not_domain: "URLs or subdomains cannot be added.",
    ignored_msg_error_saving: "There was a problem saving the domain. Please try again later.",
    ignored_msg_success: "Domain ignored successfully.",

    unignore_domain_dialog_title: "Unignore Domain",
    unignore_domain_dialog_text: "Are you sure you wish to unignore the domain: '{url}'?",
    unignore_takedown_domain_dialog_text: "This operation will close the associated pending Takedown.",

    unignore_batch_domain_dialog_title: "Unignore Domains",
    unignore_batch_domain_dialog_text: "Are you sure you wish to unignore the selected domains? Any pending takedowns associated with these domains will be closed.",

    change_classification_dialog_title: "Change Classification",
    batch_change_classification_dialog_title: "Change Classification",

    tag_edition_dialog_title: "Edit Tags for {object_name}",
    batch_tag_edition_dialog_title: "Edit Tags",
    batch_remove_tag_edition_dialog_title: "Batch Remove Tags",
    error_tags_required: "At least one tag is needed for this operation",
    tags_saved_message: "Tags saved successfully for: '{object_name}'",
    batch_tags_added_message: "Tags edited successfully for the selected elements",
    batch_tags_removed_message: "Tags removed successfully from the selected elements",
    remove_tags_instead_of_append: "Remove all selected tags from elements instead of adding them",

    note_toast_add: "Note added successfully to: '{object_name}'",
    note_toast_add_batch: "Note added successfully to the selected elements",
    note_toast_edit: "Note updated successfully for: '{object_name}'",
    note_toast_remove: "Note removed successfully from: '{object_name}'",
    add_batch_note: "Add Notes",
    add_batch_action: "Add",
    error_empty_note: "The contents of the note can not be empty",
    error_empty_emails: "Emails can not be empty",

    detections_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
    pps_block_list_csv_export_description: "Download will begin immediately after file creation.",
    schedule_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
    ignored_domains_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation. Please note this export is limited to 50,000 ignored domains.",

    add_watched_dialog_title: "Add Watched Domains",
    add_watched_summary_dialog_title: "Add Watched Domains - Summary",
    add_watched_list: "Add Domains To Watch",
    add_watched_list_placeholder: "Enter one Domain per line",
    add_watched_classification: "Select Classification (optional):",
    add_watched_classification_placeholder: "Select Classification",
    add_watched_tags: "Select one or more tags to apply (optional):",

    watched_validation_empty: "Please enter at least one domain to look up",
    watched_validation_invalid: "Please enter a valid domain (e.g.): example.com",

    watched_msg_invalid: "The domain can not be parsed or its invalid.",
    watched_msg_duplicated: "The domain already exists.",
    watched_msg_is_not_domain: "URLs or subdomains cannot be added.",
    watched_msg_error_saving: "There was a problem saving the domain. Please try again later.",
    watched_msg_success: "Domain added successfully.",
    watched_readded_msg_success: "Domain readded successfully.",

    dts_service_error: "There has been an internal error. Please try again later.",

    views_create_new: "Create New View",
    views_set_default: "Set as Default View",
    views_save_changes: "Save Changes to this View",
    views_delete_view: "Delete This View",
    views_share_view:  "Share This View",

    create_view_title: "Create New View",
    edit_view_title: "Save Changes to this View",
    edit_view_name_placeholder: "Enter name for this view",
    edit_view_share: "Share view with all account users (required for use with alerts).",
    edit_view_share_alt: "Share view with all account users.",
    create_view_button: "Create View",
    update_view_description: "Are you sure you want to update this view with the current filters? You can change the name and share settings in the process",
    update_view_button: "Save Changes",
    view_name: "View Name",
    view_saved: "Changes saved for view: '{view_name}'",
    domain_alert_dependency: "This view is used by one or more alerts and has to remain shared with all users unless the alerts are removed",
    view_name_empty: "Please specify a name for the Filter View",
    default_view_saved: "Default preferences saved for the current view.",
    delete_view_title: "Delete Current View",
    delete_view_description: "Are you sure you want to delete this view? This action cannot be undone.",
    delete_view_button: "Delete",
    view_deleted: "The selected view has been deleted",
    share_view_title: "Share this View",
    share_view_button: "Share View",
    filter_view_shared: "The shared preferences have been shared successfully",
    clear_filters: "Clear all Filters",

    saved_views: "Saved Views",
    default_views: "Predefined Views",
    custom_views: "Custom Views",
    shared_views: "Shared Views",

    domain_channels_web_tooltip: "Web",
    domain_channels_email_tooltip: "Email",
    domain_channels_social_tooltip: "Social",

    domains_tab_home: "Home",
    domains_tab_alerts: "Alerts",
    domains_tab_seeds: "Seeds",
    domains_tab_ignored: "Ignored Domains",

    batch_selected_line_1: "You have selected {selected_number} element/s to apply this operation.",
    batch_selected_line_2: "Keep in mind that the maximun number of elements for which the actions can be applied is {max_number}. If you wish to proceed only the first {max_number} will have the selected action applied.",

    batch_disabled_tooltip: "You can only perform this action for {max_number} rows at a time.",
    batch_unselected_tooltip: "You need to select at least one row to perform this action.",

    batch_ignore: "Ignore",
    batch_add_note: "Add Note",
    batch_change_classification: "Change Classification",
    batch_add_tags: "Edit Tags",
    batch_unignore: "Unignore",

    batch_tags_label: "Add Tags",
    tags_label: "Tags",
    remove_tags_label: "Remove Tags",

    pivot_registrant_email_tooltip: "See domains registered under this email in a new tab.",
    pivot_registrant_email_title: "Domains with Registrant Email: ",

    created_at: "Created at",
    updated_at: "Updated at",
    expires_at: "Expires at",

    rows_per_page: "Rows per page",
    of: "of",
    task_per_page: "Task Per Page",
    link_to_proofpoint_privacy_policy:"Link to Proofpoint Privacy Policy",
    link_to_proofpoint_terms_of_service:"Link to Proofpoint Terms of Service",

    search_domains: "Search Domains",
    search_ignored_domains: "Search Ignored Domains",

    domain_seed: "Seed",
    active: "Active",
    inactive: "Inactive",
    removal_in_progress: "(removal in progress)",
    added_on: "Added on",

    add_seeds_title: "Add Seed",
    add_seeds_action_button: "Add Seeds",
    add_domains_tld_instructions: "For a given parent domain it is not necessary to enter every TLD variation e.g. domain.com, domain.co.uk, domain.de.",
    activate_seed: "Activate seed",
    remaining_licenses: "{remaining_licenses} full domain seeds remaining",
    seed_licensing_tooltip: 'Full domain seeds detect new and historical domains.',
    remaining_limited_licenses: "{remaining_licenses} limited domain seeds remaining",
    seed_limited_licensing_tooltip: 'Limited domain seeds only detect new domains.',
    seed_placeholder: "Enter Domain",
    empty_seed: "The Domain can not be empty.",

    seed_created: "{seed} has been added successfully. After activation please allow up to 24 hours for results to populate.",
    seed_created_activation_private: "The seed has been added successfully, please enter the required information to continue with the activation process",
    create_seed_error_1: "The service is down. Please try again later.",
    create_seed_error_2: "The domain cannot be parsed or is malformed.",
    create_seed_error_3: "The domain (or a variant with a different TLD) already exists on the server.",
    create_seed_error_4: "The domain has been added successfully.",
    create_seed_error_5: "The domain has been added successfully.",
    create_seed_error_6: "The domain is too short. Please contact a Sales Representative.",
    create_seed_error_7: "The domain already exists on the service.",
    create_seed_error_8: "The seed has been added but there we not enough licenses to perform the activation",

    edit_seed_dialog_title: "Edit Seed Configuration",
    edit_seed_dialog_description: "Please provide any details from WHOIS registrations that clearly identify domains owned by your organization. We cannot identify brand owned domains for privately registered domains without this information.",
    infrastructure: "Infrastructure",
    seed_config_field_companies: "Registrant Name",
    seed_config_field_companies_ph: "Enter name or organization",
    seed_config_field_emails: "Registrant or Administrative Email Address",
    seed_config_field_emails_ph: "e.g. user@example.com or @example.com",
    seed_config_field_ips: "IP Address or IP Address Range",
    seed_config_field_ips_ph: "e.g. 192.168.1.1 or 192.168.2.1-192.168.2.254",
    seed_config_field_asns: "ASN",
    seed_config_field_asns_ph: "e.g. 7224",
    add_entry: "Add Entry",
    private_seed: "This domain is privately registered. Please provide as much of the information below as possible. Without it, we cannot identify Brand Owned domains. ",

    edit_seed_action: "Edit",
    remove_seed_action: "Remove",
    activate_seed_action: "Activate",
    deactivate_seed_action: "Deactivate",

    invalid_seed_config_field: "One or more fields are invalid.",
    seed_saved_and_activated_msg: "The seed '{url}' has been activated and the configuration values have been saved",
    seed_saved_but_not_activated_msg: "The seed '{url}' values have been saved but the Seed was not activated for lack of licenses",
    seed_saved_msg: "The configuration values for seed '{url}' have been saved.",
    seed_activated_msg: "The seed '{url}' has been activated",
    seed_deactivated_msg: "The seed '{url}' has been deactivated",
    seed_license_error_msg: "You don't have enough licenses to perform this action",

    remove_seed_dialog_title: "Remove Protected Domain",
    remove_seed_description: "Are you sure you want to remove this protected domain? By removing it you will no longer be able to detect new infringing domains for this seed.",
    remove_associated_domains: "Do you want to ignore results for this seed also? All pending Takedowns associated to the seed will be closed. ",
    seed_removed_msg: "The seed '{url}' has been removed successfully",
    batch_seed_removed_msg: "The selected seeds has been removed successfully",

    batch_remove_seed_dialog_title: "Remove Protected Domains",
    batch_remove_seed_description: "Are you sure you want to remove the selected protected domains? By removing them you will no longer be able to detect new infringing domains for these seeds.",
    batch_remove_associated_domains: "Do you want to ignore results for the selected seeds also? All pending Takedowns associated to the seeds will be closed. ",

    batch_remove: "Remove",
    batch_activate: "Activate",
    batch_deactivate: "Deactivate",

    batch_activate_seed_dialog_title: "Activate Seeds",
    batch_activate_seed_description: "Are you sure you want to activate the selected seeds?",
    batch_seed_activated_msg: "The selected seeds have been activated successfully",

    batch_deactivate_seed_dialog_title: "Deactivate Seeds",
    batch_deactivate_seed_description: "Are you sure you want to deactivate the selected seeds?",
    batch_seed_deactivated_msg: "The selected seeds have been deactivated successfully",

    tag_manager: "Manage Tags",
    search_only_unused: "Show only unused",
    search_only_removable: "Show only deletable",
    enter_search_term: "Enter search term",
    tag_deleted: "The selected tag has been deleted",

    immediate_parent_tags: "Immediate Parent Tags",
    immediate_child_tags: "Immediate Child Tags",
    tags_accounts: "Accounts",
    tags_mobile_apps: "Mobile Apps",
    tags_domains: "Domains",

    none: "None",

    tag_subscriptions: "Tag Subscriptions",
    tag_subscriptions_subtitle: "Email the selected users or teams when a domain has this tag applied",
    tag_hierarchy: "Tag Hierarchy",
    save_changes: "Save Changes",
    invalid_alert_recipients: "Some of the destinations for the alerts are invalid. Please fix them to be able to proceed",
    tag_notifications_changes_saved: "Tags changes saved.",
    tag_notifications_changes_saved_partially: "Tags changes saved. The following Tags presented circular dependencies on the hierarchy so they were partially saved: _1_",

    undo: "Undo",

    tag_cell_tooltip: "Edit tags",

    filter_or_placeholder: "Enter one or more values, separated by comma",
    filter_space_terms: "Enter one or more values, separated by space",
    filter_quotes: "Use double quotes to match values exactly",
    filter_ip_help: "Single address, address ranges, and wildcards supported.",
    filter_ip_help_2: "e.g. 192.168.1.1, 192.168.2.1-192.168.2.99, 192.168.3.*",
    filter_registrant_email_address_help_2: "Use * as a wildcard, e.g. *@example.com",

    select_customer: "Select a Customer",
    support_customer_search_placeholder: "Search customer, CTS name or datacenter",
    customer_name: "Customer",
    cts_name: "CTS Name",
    datacenter: "Datacenter",
    enter_console: "Enter Console",

    footer_copyright_v2: "© Proofpoint, Inc. __CURYEAR__ All Rights Reserved",

    proofpoint_subtitle: "Digital Risk & Compliance",

    link_privacy: "Privacy",
    link_terms: "Terms of Service",
    link_support: "Support",

    login_load_failed: "The authentication service is temporarily unavailable.",
    login_try_again: "Try again",
    login_sign_in: "Sign In",
    login_password: "Password",
    login_forgot_password: "Forgot your password?",
    login_user_center: "User Center Sign In",
    login_confirmation_email: "Didn't receive confirmation email?",
    two_factor_verification_title: "2-Step Verification",
    two_factor_loading: "Loading two-factor authentication…",
    two_factor_load_failed: "Unable to load two-factor authentication. Please try again.",
    two_factor_try_again: "Try again",
    two_factor_verification_intro: "Enter the verification code to access your account.",
    two_factor_verification_help: "If you've lost your phone or need to reset your code please contact your Proofpoint Social Media Protection Suite administrator or",
    two_factor_support: "Proofpoint Social Media Protection technical support",
    two_factor_verify: "Verify",
    two_factor_setup_title: "Two Factor Authentication Setup",
    two_factor_mandatory: "You are required to use two factor authentication by your administrator.",
    two_factor_download_title: "1. Download Google Authenticator for your phone",
    two_factor_download_apple: "Download Google Authenticator from the App Store",
    two_factor_download_google: "Download Google Authenticator from Google Play",
    two_factor_account_title: "2. Set up your account",
    two_factor_account_instructions: "Scan the barcode or enter this key:",
    two_factor_time_instructions: "Make sure your phone has the correct time.",
    two_factor_qr_code: "Two-factor authentication QR code",
    two_factor_save_title: "3. Verify and Save",
    two_factor_save_instructions: "Enter the verification code to confirm that two factor authentication is set up correctly.",
    two_factor_setup_failed: "The validation failed. Please try again or",
    two_factor_new_barcode: "generate a new barcode",
    two_factor_verify_and_save: "Verify and Save",
    forgot_password: "Forgot Password",
    forgot_password_load_failed: "Unable to load the password reset page. Please try again.",
    send_password_reset_link: "Send Password Reset Link",
    back_to_sign_in: "Back to Sign In",
    user_center_sign_in_title: "Sign In via User Center",
    user_center_logout_text: "If you do not wish to sign in with User Center credentials, please log out from User Center",
    user_center_logout: "User Center Log Out",
    user_center_load_failed: "Unable to load the User Center sign-in page. Please try again.",

    unprocessed_support_customer: 'The selected customer is yet to be processed. Please sign out, wait a moment, and try again.',
    user_not_enabled: 'An error ocurred: the selected customer is not enabled.',
    user_not_processed: 'An error ocurred: the selected user processed has not been processed yet.',

    traverse_missing_warning: 'Please wait until the next group of domains is loaded before proceding with individual navigation.',

    unwatch_domain_dialog_title: "Unwatch Domain for ",
    unwatch_domain_dialog_text: "Are you sure you want to unwatch this domain? It will no longer be accessible or visible in the application. Updates for this domain will also be ignored.",

    sign_in_for_more_details: "Sign In For More Details",

    download_video: "Download Video",
    download_transcript: "Download Transcript",

    content_view_type_split: "Split View",
    content_view_type_scroll: "Scroll View",

    review_tasks: "Review Tasks",
    review_tasks_title: "Review Tasks",

    showing_tasks: "Showing tasks",
    tasks_selected: "Tasks Selected",

    review_filter_CONTENT_PROFILE: "Content + Profile Tasks",
    review_filter_APPROVAL: "Only Content Tasks",
    review_filter_PROFILE_LOCK_REVIEW: "Only Profile Tasks",

    review_sort_SORT_ACTIVITY_DESC: "Activity Date (New → Old)",
    review_sort_SORT_ACTIVITY_ASC: "Activity Date (Old → New)",
    review_sort_SORT_DETECTION_DESC: "Detection Date (New → Old)",
    review_sort_SORT_DETECTION_ASC: "Detection Date (Old → New)",

    review_sort_SORT_TASK_CREATED_DESC: "Task Date (New → Old)",
    review_sort_SORT_TASK_CREATED_ASC: "Task Date (Old → New)",

    search_tasks_text: "Filter tasks by text",

    tasks_per_page: "Tasks/Page",

    select_all: "Select All",
    select_page: "Select Page",

    view_add_notes: "View/Add Notes",
    view_activity_notes: "View Activity/Notes",
    approve: "Approve",
    approve_and_forward: "Approve & Forward",
    reject: "Reject",
    reject_and_remove: "Reject & Remove",
    reject_and_forward: "Reject & Forward",
    forward: "Forward",
    permanently_mask_content: "Permanently Mask Content",
    //close: "Close"
    share: "Share",
    share_content: "Share Content",
    task_assign: "Task Assign",
    expand_task: "Expand Task",
    collapse_task: "Collapse Task",

    more_filters: "More Filters",
    filter_panel: "Filter Panel",
    search_filters:"Search Filters",

    date_range: "Date Range",
    profile_task_type: "Profile Task Type",
    reviewer_attributes: "Reviewer Attributes",
    task_status: "Task Status",
    content_source: "Source",
    include_closed_tasks: "Include closed tasks in results.",

    apply_filters: "Apply Filters",
    reset_filters: "Reset Filters",
    save_as_view: "Save as View",
    reset_all: "Reset",

    reset_all_filters: "Reset All Filters",
    view_name_label: "View Name (required)",
    view_name_label_required: "You must provide a name for this Filter View.",
    max_characters: "Maximum __CHARS__ characters",

    content_classifications: "Classification",

    content_task_type: "Content Task Type",
    activity_type: "Activity Type",

    content_post_review: "Captured Content",
    content_pre_review: "Submitted Content",
    content_post_curator: "Curator Submission",

    activity_type_comment: "Outbound Comment",
    activity_type_direct_message: "Outbound Direct Message",
    activity_type_post: "Outbound Post",
    activity_type_like: "Outbound Reaction",
    activity_type_outbound_reposts: "Outbound Reposts",
    activity_type_inbound_comment: "Inbound Comment",
    activity_type_inbound_direct_message: "Inbound Direct Message",
    activity_type_outbound_text_messages: "Outbound Text Messages",
    activity_type_inbound_text_messages: "Inbound Text Messages",
    activity_type_contextual_activity: "Contextual Activity",

    syndicate_library: "Syndicate Library",

    task_list_type_Item: "Captured Content",
    task_list_type_SyndicateItem: "Curator Submission",
    task_list_type_SubmittedContentItem: "Submitted Content",
    task_list_type_PreReviewItem: "Submitted Content",
    task_list_type_ReviewProfileChange: "Profile Review",
    task_list_type_ReviewProfilePrereview: "Profile Review",
    task_list_type_ReviewProfileFullPrereview: "Profile Review",
    task_list_type_ReviewProfilePostReview: "Profile Review",
    task_list_type_ReviewProfileExpiration: "Expiration Review",
    task_list_type_ReviewProfileFullExpirationReview: "Expiration Review",

    task_list_workflow_state_APPROVED: "Approved",
    task_list_workflow_state_UNAPPROVED: "Unreviewed",
    task_list_workflow_state_PENDING: "Unreviewed",
    task_list_workflow_state_REJECTED: "Rejected",
    task_list_workflow_state_REVIEWED: "Reviewed",
    task_list_workflow_state_STOPPED: "",

    content_task_status: "Content Task Status",
    profile_task_status: "Profile Task Status",

    tasks_open: "Open",
    tasks_unreviewed: "Unreviewed",
    tasks_started: "Started",
    tasks_closed: "Closed",
    tasks_approved: "Approved",
    tasks_rejected: "Rejected",
    tasks_reviewed: "Reviewed",
    tasks_new: "New",

    content_note_toast_add: "Note added successfully",
    retrieve_content_notes: "Retrieve Content Notes",
    add_content_note: "Add Content Note",
    retrieve_sharing_info: "Retrieve Sharing Info",
    task_assignment_users: "Task Assignment Users",
    task_list_attributes: "Task List Attributes",

    content_share_toast: "Content shared successfully",

    item_apps: "Publishing Application",

    author_type: "Activity By",
    author_type_account: "Protected Account",
    author_type_third_party: "Third-Party",

    reviewer_attribute_has_notes: "Has Notes",
    reviewer_attribute_unassigned: "Unassigned",
    reviewer_attribute_assigned_to_me: "Assigned to Me",
    reviewer_attribute_assigned_to_others: "Assigned to Others",


    select_multi_placeholder: "Select one or more filters",
    select_multi_search_placeholder: "Type at least 3 characters to perform the search",

    policy_match: "Policy Match",
    matching_text: "Matching Text",
    classifier_documentation: "Classifier Documentation",
    general_documentation: "General Documentation",
    proofpoint_radar: "Proofpoint Channel Insights",
    policy_matches: "Policy Matches",

    base_v1: "Digital Risk & Compliance",
    category_reference: "Category Reference",

    approve_content_item: "Approve {selected_items} Content Item",
    approve_content_items: "Approve {selected_items} Content Items",
    approve_content: "Approve Content",

    mark_reviewed: "Mark Reviewed",
    mark_reviewed_content_item: "Mark {selected_items} Content Item as Reviewed",
    mark_reviewed_content_items: "Mark {selected_items} Content Items as Reviewed",
    mark_reviewed_content: "Mark Content as Reviewed ",

    reject_content_item: "Reject {selected_items} Content Item",
    reject_content_items: "Reject {selected_items} Content Items",
    reject_content: "Reject Content",

    reject_remove_content_item: "Reject and Remove {selected_items} Content Item",
    reject_remove_content_items: "Reject and Remove {selected_items} Content Items",
    reject_remove_content: "Reject and Remove Content",

    task_assignment_edit_item: "Edit Assignment for {selected_items} Task",
    task_assignment_edit_items: "Edit Assignments for {selected_items} Tasks",
    task_assignment_edit: "Edit Assignment",
    task_assignment_edit_notes: "Note (optional)",
    task_assignment_edit_notes_placeholder: "Please add a note",
    task_assignment_edit_notes_required: "Please add a note",
    task_assignment_edit_current_assignee: "Current Assignee",
    task_assignment_edit_new_assignee: "New Assignee",
    task_assignment_user: "Assignee",
    task_assignment_user_placeholder: "Please select an option",
    task_assignment_user_required: "Please select an option",

    activity_already_removed: "The activity is already removed. It may have been removed by the account owner prior to you attempting to delete it.",

    batch_content_processing_completed: "{count} content tasks completed.",
    batch_content_processing_failed_tasks: "{action} action was not allowable for {count} content tasks.",
    batch_processing_completed: "Batch processing is complete. The content list will reload with updated status.",
    batch_processing_failed: "Batch processing failed and could result into errors",
    batch_reject_remove_incomplete: "{partial} content tasks were only allowed to be rejected.",

    batch_task_assignment_processing_completed: "{count,plural,=1 {{count} task was assigned.} other {{count} tasks were assigned.}}",
    batch_task_assignment_failed_success_tasks: "{count,plural,=1 {{username} is not authorized to review all of the tasks you have selected. Therefore 1 task for which {username} is authorized to review was assigned.} other {{username} is not authorized to review all of the tasks you have selected. Therefore {count} tasks for which {username} is authorized to review were assigned.}}",
    batch_task_assignment_failed_tasks: "{username} is not authorized to review any of the tasks you have selected.",

    custom_category_postfix: " (Custom)",

    beta: "Beta",

    remediation_time: "Remediation Time (minutes per incident)",
    review_time: "Review Time (minutes per content item)",
    labor_cost: "Labor Cost (USD per hour)",
    roi_validation_message:"Only positive numbers are accepted.",
    cost_savings_formula: "Cost Savings Formula",
    update_cost_savings_estimates:"Update Cost Savings Estimates",
    savings_formula: "Savings = [ Remediation Time (mins) * Incidents Remediated + Review Time (mins) * Content Items Reviewed ] * [ Labor Cost (USD per hour) ÷ 60 (mins) ]",

    user_management_title: "User Management",
    participants_tab: "Participant Users",
    system_users_tab: "System Users",
    participants_text_search: "Search by name, email or account name",
    system_users_text_search: "Search by name or email address",
    role_placeholder: "Select a Role",

    filters_panel_2: "Filter Panel",
    columns_panel_2: "Columns Panel",

    participant_users: "Participant Users",
    system_users: "System Users",
    email_address: "Email Address",
    auth_method: "Auth Method",
    assigned_subtenants: "Assigned Subtenants",
    teams: "Teams",
    select_teams: "Select one or more teams",
    role: "Role",
    is_user_center_user: "Require user to authenticate against User Center",

    participant_state_PROVISIONED: "Provisioned",
    participant_state_ACTIVE: "Active",
    participant_state_PARTIALLY_ACTIVE: "Partially Active",
    participant_state_EXPIRED: "Expired",
    participant_state_DEACTIVATED: "Deactivated",
    participant_state_UNINSTALLED: "Uninstalled",

    profile_status_approved: "Approved",
    profile_status_pending: "Pending",
    profile_status_expired: "Expired",

    participant_auth_state_active: "Active",
    participant_auth_state_expired: "Expired",
    participant_auth_state_deactivated: "Deactivated",
    participant_auth_state_uninstalled: "Uninstalled",

    participant_action_terminate: "Remove Participant User",
    participant_batch_action_terminate: "Remove {selection_counter} Participant User{plural}",
    participant_terminate_button: "Remove Participant",
    participant_terminate_button_plural: "Remove Participants",
    participant_terminate_dialog_text: "Are you sure you want to remove the {name} ({email}) as a participant user? This operation cannot be undone.",
    participant_terminate_message: "{name} ({email}) has been removed as a participant user.",
    participant_batch_terminate_dialog_text: "Are you sure you want to remove this participant user? This operation cannot be undone.",
    participant_batch_terminate_dialog_plural_text: "Are you sure you want to remove these participant users? This operation cannot be undone.",
    batch_terminate_participants: "Remove Participant Users",
    participant_batch_terminate_message: '{count} participant user has been removed.',
    participant_batch_terminate_message_plural: '{count} participant users have been removed.',

    batch_edit_participants: "Edit Participant Users",

    batch_edit_system_users: "Edit System Users",

    participant_batch_action_edit_plural: "Edit {selection_counter} Participant Users",
    participant_batch_action_edit: "Edit {selection_counter} Participant User",

    system_user_batch_action_edit_plural: "Edit {selection_counter} System Users",
    system_user_batch_action_edit: "Edit {selection_counter} System User",

    participant_action_edit: "Edit Participant User",

    participant_action_send_token_reauth_email: "Send Token Reauthorization Email",
    participant_token_reauth_email_sent: "Token reauthorization email sent to {email}",

    add_participant_groups: "Add Labels",
    remove_participant_groups: "Remove Labels",

    add_assigned_subtenants: "Add Assigned Subtenants",
    remove_assigned_subtenants: "Remove Assigned Subtenants",

    add_teams: "Add Teams",
    remove_teams: "Remove Teams",

    system_user_status_ENABLED: "Enabled",
    system_user_status_DISABLED: "Disabled",
    system_user_status_TERMINATED: "Terminated",

    system_user_action_disable: "Disable System User",
    system_user_action_enable: "Enable System User",
    system_user_action_reset_password: "Reset Password",
    system_action_terminate: "Remove System User",
    system_terminate_dialog_text: "Are you sure you want to remove the {name} ({email}) as a system user? This operation cannot be undone.",
    system_user_terminate_button: "Remove System User",
    system_user_terminate_message: "{name} ({email}) has been removed as a system user.",

    system_user_enabled_message: "{name} has been enabled.",
    system_user_disabled_message: "{name} has been disabled.",
    system_user_reset_password_message: "Password reset initiated for {name}.",

    system_user_auth_method_SSO: "SSO",
    system_user_auth_method_USER_CENTER: "User Center",
    system_user_auth_method_ONE_FACTOR: "One Factor",
    system_user_auth_method_TWO_FACTOR: "Two Factor",

    entity_config: "Entity Config",
    access_policy: "Access Policy",
    proxy_policy: "Access Policy",
    subtenant: "Subtenant",
    auth_state: "Account State",
    profile_account_status: "Profile State",
    grouping_values: "Labels",
    participant_groups: "Labels",
    must_match_all: "Must match all selected Labels.",

    account_auth_state_active: "Active",
    account_auth_state_expired: "Expired",
    account_auth_state_deactivated: "Deactivated",
    account_auth_state_uninstalled: "Uninstalled",

    issues_counter: "{count} Issues",
    participant_empty_accounts: "The selected participant does not have associated accounts",

    uninstall: "Uninstall",
    uninstall_patrol: "Uninstall Patrol",
    send_token_reauth_email: "Send Reauth Email",
    create_profile_review: "Create Profile Review",

    account_tags: "Account Tags",
    edit_columns: "Edit Columns",
    apply_changes: "Apply Changes",
    reset_columns: "Reset to Default",

    new_user: "New User",
    add_user: "Add User",
    export_data: "Export Data",
    import_data: "Import Data",
    choose_file: "Choose File",
    file_not_selected_error: "Please select a file to continue",
    add_participant_user: "Add Participant User",
    edit_participant_user: "Edit Participant User",
    participant_import_data_description: "Select and import a CSV file to update your participant user data.",
    cpum_upload_successful: "Your User file has been successfully uploaded and may take time to process. An email will be sent to you when processing is complete.",


    users_csv_export_description: "This export may take over a minute to create the CSV File. Download will begin immediately after file creation.",

    add_system_user: "Add System User",
    edit_system_user: "Edit System User",

    first_name: "First Name",
    last_name: "Last Name",

    select: "Select",
    enter: "Enter",

    participant_created: "{name} ({email}) has been added. Any existing accounts using this email will link to this user momentarily.",
    participant_updated: "{name} ({email}) has been updated. Changes on install configurations might take a couple of minutes to propagate to existing accounts.",

    system_user_created: "{name} has been created.",
    system_user_updated: "{name} has been updated.",

    invalid_email_address: "Invalid Email Address",

    required: "Required",
    invalid_first_name: "Invalid First Name",
    invalid_last_name: "Invalid Last Name",
    invalid_role: "Please select a Role",
    empty_subtenants: "Please assign at least one subtenant to this user.",
    invalid_participant_groups: "There is at least one newly added Labels that is not formatted correctly",
    email_address_in_use: "The email address is already in use",
    update_no_changes: "There were no changes applied to the Participant User",

    records_with_errors: "There have been {records_with_errors} record(s) with errors.",

    user_single: 'user',
    users_plural: 'users',
    participant_batch_edit_records_with_errors_single: "1 participant user could not be updated because its entity config is in a different subtenant. ",
    participant_batch_edit_records_with_errors_plural: "{records_with_errors} participant users could not be updated because their entity config is in a different subtenant. ",
    participant_batch_edit_records_unchanged_single: "1 participant user was not modified",
    participant_batch_edit_records_unchanged_plural: "{records_unchanged} participant users were not modified",
    participant_batch_edit_records_successful: "Changes saved for {records_successful} participant {users}",

    system_user_batch_edit_records_with_errors: "{records_with_errors} {users} could not be updated.",
    system_user_batch_edit_records_unchanged_single: "{records_unchanged} system user was not modified.",
    system_user_batch_edit_records_unchanged_plural: "{records_unchanged} system users were not modified.",
    system_user_batch_edit_records_successful: "Changes saved for {records_successful} system {users}.",

    create_profile_review_button: 'Create Review',
    participant_account_empty_review_disabled: 'A profile review is already pending for this account',
    participant_account_empty_review_description: 'Are you sure you want to create a profile review for {account_name}?',
    participant_account_empty_review_created: 'A profile review was created for {account_name}',

    uninstall_patrol_from_account_description: 'Are you sure you want to Uninstall Patrol from {account_name}?',
    participant_account_uninstalled: 'Patrol uninstalled from {account_name}',

    set_to_none: "(Set to none)",
    edit_access_policy: "Edit Access Policy",
    edit_entity_config: "Edit Entity Config",

    select_a_filter: "Select a filter",

    participant_action_send_welcome_email: "Send Welcome Email",
    participant_welcome_mail_sent: "The welcome email has been sent to the participant.",

    section: "Section",
    profile_field: "Profile Field",
    before_value: "Before Value",
    after_value: "After Value",

    add_profile_section: "Add Profile Section",
    finalize_review: "Finalize Review",
    profile_for: "Profile for",

    message_exclusion_rules_title: "Message Exclusion Rules",
    create_new_rule: "Create New Rule",
    rule_criteria: "Rule Criteria",
    office_tenants_using_rule: "Office Tenants Using Rule",
    messages_matching_rule: "# Messages Matching Rule",
    edit_rule: "Edit Rule",
    edit_tenants: "Edit Tenants",
    delete_rule: "Delete Rule",
    rule: "Rules",
    create_rule_title: "Edit Rule : Untitled",
    edit_rule_title: "Edit Rule: {rule_name}",
    save_rule: "Save Rule",
    exclusion_rule_name: "Rule Name",
    add_condition: "Add Condition",
    message_header: "Message Header",
    matching_logic: "Matching Logic",
    remove_condition: "Remove Condition",
    matching_value: "Matching Value",
    select_message_header: "Select or enter a custom header value",
    select_matching_logic: "Select matching logic",
    enter_name: "Enter name",
    message_exclusion_contains: 'contains',
    message_exclusion_equals: 'equals',
    message_exclusion_not_equals: 'does not equal',
    message_exclusion_not_contain: 'does not contain',
    message_exclusion_edit_rule_text: "Exclude Messages from the Rapid Risk Assessment when ALL the following conditions are met..",
    message_exclusion_rule_provide_a_name: 'You must enter a rule name',
    message_exclusion_rule_invalid_name: 'Please enter a valid name',
    create_at_least_one_condition: 'You must enter at least one condition',
    matching_header_invalid_value: 'You must select or enter a header name',
    matching_logic_invalid_value: 'You must select the matching logic',
    matching_value_invalid_value: 'you must enter a matching value',
    message_exclusion_delete_dialog_text: 'Are you sure you want to delete this message exclusion rule?This operation cannot be undone.',
    message_exclusion_delete_dialog_title: 'Delete Rule Confirmation',
    message_exclusion_rule_saved_message: "Message Exclusion Rule '{name}' has been saved.",
    message_exclusion_rule_removed_message: "Message Exclusion Rule '{name}' has been removed."
}
